// Collection tab
let categoryCards = document.querySelectorAll(".custom_collection_tab_card");
var collectionTitleTop = document.querySelectorAll(".collec_heading_title");
var collectionTitle = document.querySelectorAll(".collec_heading--content");
var productGrid = document.querySelectorAll(".product-grid");

categoryCards.forEach((card) => {
  card.addEventListener("click", () => {
    categoryCards.forEach((card) => {
      card.classList.remove("custom_collection_tab_card_selected");
    });

    card.classList.add("custom_collection_tab_card_selected");
  });
});

function toggleDisplayTitle(id) {
  collectionTitleTop.forEach((element) => {
    let elemId = element.getAttribute("data-collection_id");
    if (elemId !== id) {
      element.style.display = "none";
    } else {
      element.style.display = "block";
    }
  });
}

function toggleDisplayCollTitle(id) {
  collectionTitle.forEach((element) => {
    let elemId = element.getAttribute("data-collection_id");
    if (elemId !== id) {
      element.style.display = "none";
    } else {
      element.style.display = "block";
    }
  });
}

function toggleDisplayProducts(id) {
  productGrid.forEach((element) => {
    let elemId = element.getAttribute("data-collection_id");

    if (elemId !== id) {
      element.style.display = "none";
    } else {
      element.style.display = "flex";
    }
  });
}

categoryCards.forEach((card) => {
  card.addEventListener("click", function () {
    collection_id = card.getAttribute("data-collection_id");
    toggleDisplayCollTitle(collection_id);
    toggleDisplayTitle(collection_id);
    toggleDisplayProducts(collection_id);
  });
});

//scroll to top while click on the collection tab

categoryCards.forEach(card => {
  card.addEventListener("click", scrollToTop);
});

function scrollToTop() {
  window.scrollTo({
    top: 300,
    behavior: 'smooth', 
  });
}

// sticky Cart Bar
const stickyBars = document.querySelectorAll(
  ".custom-sticky-cart-info-container"
);

// function showStickyBar() {
//   stickyBars.forEach(function (stickyBar) {
//     if (window.screen.width > 768) {
//       stickyBar.style.display = "none";
//     } else {
//       stickyBar.style.display = "flex";
//     }
//   });
// }

// var reloadOnce = true;
// window.addEventListener("resize", function () {
//   if (window.innerWidth <= 768 && reloadOnce) {
//     location.reload();
//     reloadOnce = false;
//   }
// });
// showStickyBar();

document.addEventListener("DOMContentLoaded", function () {
  let quickAddButtons = document.querySelectorAll(".quick-add__submit");
  let stickyBars = document.querySelectorAll(
    ".custom-sticky-cart-info-container"
  );

  const updateOnLoad = async () => {
    try {
      const req = await fetch("/cart.js");
      if (!req.ok) {
        throw new Error("Network response was not ok");
      }
      const res = await req.json();

      // console.log(res);

      if (res.items) {
        res.items.forEach((item) => {
          let prd = document.getElementById(item.id);
          if (prd) {
            prd.querySelector(".quick-add").style.display = "none";
            prd.querySelector(".ctm-quantity_wrapper").style.display = "flex";
            prd.querySelector(".ctm-quantity_wrapper .ctm-qty__input").value =
              item.quantity;
          }
        });

        if (res.item_count != 0) {
          // console.log("hide");
          // stickyBars.forEach( e => e.style.display = 'none');
          // stickyBars.forEach( e => e.style.display = 'flex');

          stickyBars.forEach(function (stickyBar) {
            if (window.screen.width > 768) {
              stickyBar.style.display = "none";
            } else {
              stickyBar.style.display = "flex";
            }
          });
        }

        if (document.querySelector("#cart-icon-bubble .cart-inner-item")) {
          if (res.item != 1) {
            document
              .querySelectorAll(".cus-cart-count-container span")
              ?.forEach((count) => (count.innerText = res.item_count));
          }
          document.querySelectorAll(".price-container span").forEach((e) => {
            let totalPrice = res?.total_price / 100;
            totalPrice = totalPrice.toLocaleString("en-IN"); // Convert to Indian number format
            e.innerText = "Rs. " + totalPrice;
          });
        } else {
          console.log("not found A");
        }

        document.querySelector(".custom-sticky-cart-info-container")
          ? (document.querySelector(".items-container").innerText =
              res.item_count + " items")
          : "";
      }
    } catch (error) {
      console.error("Error updating product qty:", error);
    }
  };

  const hideCart = async () => {
    try {
      const req = await fetch("/cart.js");
      if (!req.ok) {
        throw new Error("Network response was not ok");
      }
      const res = await req.json();

      //   console.log('aaa', res);

      if (res.item_count < 1) {
        // console.log('hide');
        stickyBars.forEach((e) => (e.style.display = "none"));
      }
    } catch (error) {
      console.error("Error updating product qty:", error);
    }
  };

  updateOnLoad();

  //Fetching Cart to update values
  const updatePrdQty = async (elm, vId) => {
    try {
      // console.log("function called");
      const req = await fetch("/cart.js");

      if (!req.ok) {
        throw new Error("Network response was not ok");
      }

      const res = await req.json();
      // console.log(res,'res is here');

      // elm.closest(".card").querySelector(".ctm-quantity_wrapper .ctm-qty__input").value = 1;

      res?.items.forEach((item) => {
        // console.log(item.quantity,'id is',vId,'itm');
        // console.log(item.id,'itm id');
        if (item.id == parseInt(vId)) {
          // console.log('in if');
          elm
            .closest(".card")
            .querySelector(".ctm-quantity_wrapper .ctm-qty__input").value =
            item.quantity;
        }
        // console.log('updatePrdQty',item);
      });

      //need to add media query
      // stickyBars.forEach( e => e.style.display = 'flex');  //here

      // console.log('updatePrd',res);
      stickyBars.forEach(function (stickyBar) {
        if (window.screen.width > 768 || res.item_count < 1) {
          stickyBar.style.display = "none";
        } else {
          stickyBar.style.display = "flex";
        }
      });

      // if(document.querySelector('#cart-icon-bubble .cart-inner-item')){
      //   if (res.item != 1) {
      //     document.querySelectorAll(".cus-cart-count-container span")?.forEach((count) => (count.innerText = res.item_count));
      //   }
      //   document.querySelectorAll(".price-container span").forEach((e) => {
      //     let totalPrice = res?.total_price / 100;
      //     totalPrice = totalPrice.toLocaleString('en-IN'); // Convert to Indian number format
      //     e.innerText = 'Rs. ' + totalPrice;
      //   });
      // }else{
      //     console.log('not found B');
      // }

      // stickyBar updation
      document
        .querySelectorAll(
          ".custom-sticky-cart-info-container .price-container span"
        )
        .forEach((e) => {
          let totalPrice = res?.total_price / 100;
          totalPrice = totalPrice.toLocaleString("en-IN"); // Convert to Indian number format
          e.innerText = "Rs. " + totalPrice;
        });
      document.querySelector(".items-container").innerText =
        res.item_count + " items";
    } catch (error) {
      console.error("Error updating product qty:", error);
    }
  };

  //on ATC click hide and show qty selector and update values
  quickAddButtons?.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      let vID = btn
        .closest(".card")
        .querySelector(".ctm-quantity_wrapper .ctm-qty__input")
        .getAttribute("data-quantity-variant-id");

      btn.querySelector(".ctm_loader").style.display = "block";

      setTimeout(() => {
        updatePrdQty(btn, vID);
        btn.closest(".quick-add").style.display = "none";
        btn
          .closest(".card")
          .querySelector(".ctm-quantity_wrapper").style.display = "flex";
        btn.querySelector(".ctm_loader").style.display = "none";
      }, 700);
    });
  });

  //Qty selector plus and minus functions
  let qtyMinus = document.querySelectorAll(".ctm_qty-minus");
  let qtyPlus = document.querySelectorAll(".ctm_qty-plus");

  qtyMinus?.forEach((e) => {
    e.addEventListener("click", () => {
      let inputField = e
        .closest(".ctm-quantity_wrapper")
        ?.querySelector(".ctm-qty__input");
      let val = parseInt(inputField.value);
      if (val > 0) {
        inputField.value = val - 1;

        setTimeout(() => {
          hideCart();
        }, 100);

        if (inputField.value == 0) {
          inputField
            .closest(".card")
            .querySelector(".quick-add").style.display = "block";
          inputField.closest(".ctm-quantity_wrapper").style.display = "none";
        }
      }
    });
  });

  qtyPlus?.forEach((e) => {
    e.addEventListener("click", () => {
      let inputField = e
        .closest(".ctm-quantity_wrapper")
        ?.querySelector(".ctm-qty__input");
      let val = parseInt(inputField.value);
      inputField.value = val + 1;
    });
  });

  // update cart
  const updateCart = async (cartUpdate) => {
    try {
      const req = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartUpdate),
      });

      if (!req.ok) {
        throw new Error("Network response was not ok");
      }
      const res = await req.json();
      // console.log(res.item_count);

      // stickyBars.forEach( e => e.style.display = 'flex');

      stickyBars.forEach(function (stickyBar) {
        if (window.screen.width > 768 || res.item_count < 1) {
          stickyBar.style.display = "none";
        } else {
          stickyBar.style.display = "flex";
        }
      });

      document.querySelectorAll(".cart-inner-item").forEach((item, index) => {
        if (res.item_count == 0) {
          item.style.display = "none";
        }
      });

      // console.log(res);
      if (document.querySelector("#cart-icon-bubble .cart-inner-item")) {
        if (res.item != 1) {
          document
            .querySelectorAll(".cus-cart-count-container span")
            ?.forEach((count) => (count.innerText = res.item_count));
        }
        document.querySelectorAll(".price-container span").forEach((e) => {
          let totalPrice = res?.total_price / 100;
          totalPrice = totalPrice.toLocaleString("en-IN"); // Convert to Indian number format
          e.innerText = "Rs. " + totalPrice;
        });
      } else {
        console.log("not found C");
      }

      document.querySelector(".items-container").innerText =
        res.item_count + " items";
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  //Update cart on qty minus and plus btn click
  document
    .querySelectorAll(".ctm-quantity_wrapper .ctm-qty__btn")
    ?.forEach((btn) => {
      if (btn) {
        btn.addEventListener("click", function () {
          let input = btn
            .closest(".ctm-quantity_wrapper")
            .querySelector(".ctm-qty__input");
          const vIDel = input.getAttribute("data-quantity-variant-id");
          const updateData = {
            quantity: input.value,
            id: vIDel,
          };

          // console.log(updateData);

          updateCart(updateData);
        });
      } else {
        console.error("btn element not found");
      }
    });
});

// document.addEventListener('DOMContentLoaded', function () {
//   let quickAddButtons = document.querySelectorAll('.quick-add__submit');
//   let quantityWrappers = document.querySelectorAll('.quantity_wrapper');

//   quickAddButtons.forEach((button, index) => {
//     button.addEventListener('click', () => {
//       button.style.display = 'none';
//       quantityWrappers[index].style.display = 'block';
//     });
//   });

//   // update cart
//   const updateCart = async (cartUpdate) => {
//     try {
//       const req = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(cartUpdate),
//       });

//       if (!req.ok) {
//         throw new Error('Network response was not ok');
//       }
//       const res = await req.json();
//       console.log(res);
//       document.querySelectorAll('.cart-count-bubble span')?.forEach((count) => (count.innerText = res?.item_count));
//  document.querySelectorAll('.price-container span').forEach( e => e.innerText = res?.total_price / 100 );
//       document.querySelector('.items-container').innerText = res?.item_count + ' items';
//     } catch (error) {
//       console.error('Error updating cart:', error);
//     }
//   };

//   document.querySelectorAll('.quantity__input__mw')?.forEach((input) => {
//     input.addEventListener('change', function () {
//       const vIDel = this.getAttribute('data-quantity-variant-id');
//       const updateData = {
//         quantity: this.value,
//         id: vIDel,
//       };
//       updateCart(updateData);
//     });
//   });
// });



